import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  DatePicker,
  DatePickerProps,
  Drawer,
  Flex,
  Form,
  FormInstance,
  FormProps,
  Input,
  notification,
} from "antd";
import {
  Calendar,
  CallCalling,
  Man,
  Woman,
  Convert3DCube,
} from "iconsax-react";
import dayjs from "dayjs";
import { mixGetV1, mixPostV1, mixPutV1 } from "../../services/mixin";
import type { Dayjs } from "dayjs";

// const dateFormat = 'MM/DD/YYYY';
const { TextArea } = Input;

const closeIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {" "}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.86312 3.86363C4.03189 3.6949 4.26077 3.60012 4.49942 3.60012C4.73806 3.60012 4.96694 3.6949 5.13572 3.86363L8.99942 7.72733L12.8631 3.86363C12.9461 3.77767 13.0455 3.7091 13.1553 3.66194C13.2651 3.61477 13.3832 3.58994 13.5027 3.5889C13.6222 3.58786 13.7407 3.61063 13.8513 3.65589C13.9619 3.70114 14.0624 3.76797 14.1469 3.85247C14.2314 3.93697 14.2982 4.03746 14.3435 4.14807C14.3887 4.25867 14.4115 4.37719 14.4104 4.49669C14.4094 4.61619 14.3846 4.73429 14.3374 4.84409C14.2902 4.95389 14.2217 5.0532 14.1357 5.13623L10.272 8.99993L14.1357 12.8636C14.2997 13.0334 14.3904 13.2607 14.3883 13.4967C14.3863 13.7327 14.2916 13.9584 14.1248 14.1253C13.9579 14.2921 13.7322 14.3868 13.4962 14.3888C13.2602 14.3909 13.0329 14.3002 12.8631 14.1362L8.99942 10.2725L5.13572 14.1362C4.96598 14.3002 4.73863 14.3909 4.50266 14.3888C4.26668 14.3868 4.04095 14.2921 3.87408 14.1253C3.70721 13.9584 3.61256 13.7327 3.61051 13.4967C3.60846 13.2607 3.69918 13.0334 3.86312 12.8636L7.72682 8.99993L3.86312 5.13623C3.69439 4.96745 3.59961 4.73857 3.59961 4.49993C3.59961 4.26128 3.69439 4.0324 3.86312 3.86363Z"
      fill="#6B7280"
    />{" "}
  </svg>
);

interface Props {
  id?: number;
  isShow?: boolean;
  onPopupClose?: () => void;
  onSuccess?: () => void;
}

type FieldType = {
  fullName?: string;
  phoneNumber?: string;
  address?: string;
  staff?: string;
  gender?: number;
  dob?: string;
  checkin_code?: string | number;
  role_id?: number;
};

const EditStaffPopup: React.FC<Props> = (props) => {
  const { id, isShow = false, onPopupClose, onSuccess } = props;
  const [open, setOpen] = useState(isShow);
  const [genders, setGenders] = useState([] as any);
  const [roleStaff, setRoleStaff] = useState([] as any);
  const [dob, setDob] = useState<any>();
  const [detail, setDetail] = useState<any>({});
  const [selectedGender, setSelectedGender] = useState<number | undefined>();
  const [selectedRole, setSelectedRole] = useState<number | undefined>();

  useEffect(() => {
    setOpen(isShow);

    if (isShow) {
      getGenders();
      getRoleStaff();
      getDetail(Number(id));
    }
  }, [isShow, id]);

  // DOB CHANGE
  const onDobChange: DatePickerProps<Dayjs[]>["onChange"] = (
    date,
    dateString,
  ) => {
    setDob(dateString);
  };

  // GET GENDER
  const getGenders = async () => {
    const res = await mixGetV1("/api/checkin/gComboGender.php", {});

    if (res.status === 1) {
      setGenders(res.data);
    }
  };

  // GET RoleStaff
  const getRoleStaff = async () => {
    const res = await mixGetV1("/api/webAdmin/gComboRoleStaff.php", {});

    if (res.status === 1) {
      setRoleStaff(res.data);
    }
  };

  // GET DETAIL
  const getDetail = async (id: number) => {
    const res = await mixPostV1("/api/webAdmin/gInfoStaffEdit.php", {
      staff_id: id,
    });

    if (res.status === 1) {
      setDetail(res.data);
      const data = {
        fullName: res.data.staff_name,
        phoneNumber: res.data.phone_number,
        address: res.data.address,
        gender: res.data.gender_id,
        dob: res.data.birthday,
        role_id: res.data.role_id,
        checkin_code: res.data.checkin_code,
      };
      setDob(data.dob);
      setSelectedGender(data.gender);
      setSelectedRole(data.role_id);
      formRef.current?.setFieldsValue(data);
    }
  };

  const onClose = () => {
    setOpen(false);
    if (onPopupClose) {
      onPopupClose();
    }
  };

  // FORM SUBMIT
  const formRef = useRef<FormInstance<FieldType>>(null);
  const onSubmitForm = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };

  // FORM SUBMIT SUCCESSFULLY
  const [confirmLoading, setConfirmLoading] = useState(false);
  const handleOk = async (values: any) => {
    setConfirmLoading(true);

    const params = {
      staff_id: id,
      staff_name: values.fullName,
      phone_number: values.phoneNumber,
      address: values.address,
      gender_id: values.gender,
      birthday: dob,
      role_id: values.role_id,
      checkin_code: values.checkin_code,
    };
    const res = await mixPutV1("/api/webAdmin/editStaffByStore.php", params);

    if (res.status === 1) {
      setConfirmLoading(false);
      onClose();
      openNotification();

      if (onSuccess) {
        onSuccess();
      }
    } else {
      setConfirmLoading(false);
      openNotification("error", res.message);
    }
  };
  const onFinish: FormProps<FieldType>["onFinish"] = (values) => {
    handleOk(values);
  };

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "info" | "warning" | "error" = "success",
    message = "Staff updated!",
  ) => {
    api[type]({
      message: message,
      placement: "bottomRight",
      className: "single-message",
    });
  };

  // POPUP FOOTER
  const Footer = (
    <>
      <Button className="rs-button default-outlined" onClick={onClose}>
        Close
      </Button>
      <Button
        type="primary"
        loading={confirmLoading}
        className="rs-button"
        onClick={onSubmitForm}
      >
        Update
      </Button>
    </>
  );

  const checkPhone = (_: any, value: any) => {
    if (!/^\d{10}$/.test(value) && value) {
      return Promise.reject(
        new Error("Phone number is not in the correct format!"),
      );
    }
    return Promise.resolve();
  };

  const checkCode = (_: any, value: any) => {
    if (!/^\d{6}$/.test(value) && value) {
      return Promise.reject(
        new Error("Check code number is not in the correct format!"),
      );
    }
    return Promise.resolve();
  };

  return (
    <>
      {contextHolder}

      <Drawer
        title="Edit staff"
        rootClassName="rs-drawer w-338 footer-with-2-button"
        open={open}
        footer={Footer}
        closeIcon={closeIcon}
        onClose={onClose}
      >
        <Form
          ref={formRef}
          onFinish={onFinish}
          autoComplete="off"
          className="rs-form"
          layout="vertical"
          requiredMark={false}
        >
          <Form.Item<FieldType>
            label="Name"
            name="fullName"
            rules={[{ required: true, message: "This field must be filled!" }]}
          >
            <Input placeholder="Full name" className="rs-input" />
          </Form.Item>

          <Form.Item label="Gender" name="gender">
            <Flex align="center" gap={8}>
              {genders.map((item: any) => (
                <label
                  key={item.id}
                  className="custom-radio"
                  style={{ width: "100%" }}
                >
                  <input
                    type="radio"
                    name="gender"
                    value={item.id}
                    checked={item.id === selectedGender}
                    onChange={() => {
                      setSelectedGender(item.id);
                      formRef.current?.setFieldsValue({ gender: item.id });
                    }}
                  />
                  {item.id === 1 && <Man variant="Bulk" size={20} />}
                  {item.id === 2 && <Woman variant="Bulk" size={20} />}
                  <span>{item.gender_name}</span>
                  <span className="custom-radio-icon"></span>
                </label>
              ))}
            </Flex>
          </Form.Item>

          <Form.Item label="DOB">
            <DatePicker
              className="rs-date-picker"
              popupClassName="rs-date-picker-dropdown"
              style={{ width: "100%" }}
              suffixIcon={<Calendar size={18} variant="Bulk" />}
              // format={dateFormat}
              value={[dayjs(dob)]}
              onChange={onDobChange}
            />
          </Form.Item>

          <Form.Item<FieldType>
            label="Phone number"
            name="phoneNumber"
            rules={[
              { validator: checkPhone },
              { required: true, message: "This field must be filled!" },
            ]}
          >
            <Input
              placeholder="Phone number"
              className="rs-input"
              prefix={<CallCalling size={18} variant="Bulk" />}
              count={{
                show: true,
                max: 10,
                strategy: (txt) => txt.length,
                exceedFormatter: (txt, { max }) =>
                  txt.split("").slice(0, max).join(""),
              }}
            />
          </Form.Item>

          <Form.Item<FieldType> label="Address" name="address">
            <TextArea placeholder="Address" className="rs-input" rows={7} />
          </Form.Item>

          <Form.Item<FieldType>
            label="Checkin code"
            name="checkin_code"
            rules={[{ validator: checkCode }]}
          >
            <Input
              placeholder="Checkin code (6 numbers)"
              className="rs-input"
              prefix={<Convert3DCube size={18} variant="Bulk" />}
            />
          </Form.Item>

          {roleStaff.length > 0 && (
            <Form.Item label="Role" name="role_id">
              <Flex align="center" gap={8}>
                {roleStaff.map((item: any) => (
                  <label
                    key={item.role_id}
                    className="custom-radio"
                    style={{ width: "100%" }}
                  >
                    <input
                      type="radio"
                      name="role_id"
                      value={item.role_id}
                      checked={item.role_id === selectedRole}
                      onChange={() => {
                        setSelectedRole(item.role_id);
                        formRef.current?.setFieldsValue({
                          role_id: item.role_id,
                        });
                      }}
                    />
                    <span>{item.role_name}</span>
                    <span className="custom-radio-icon"></span>
                  </label>
                ))}
              </Flex>
            </Form.Item>
          )}
        </Form>
      </Drawer>
    </>
  );
};

export default EditStaffPopup;
